import { createRef, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Loading from "../../loading/Loading";
import UserLayout from "../layout/UserLayout";
import SearchableSelect from "../../common/SearchableSelect";
import {
	apenasNumeros,
	cpf_cnpj_mask,
	cpf_mask,
	createFuncionario,
	getFuncionarios,
	pis_mask,
	telefone_mask,
} from "../../../services/Servicos";
import { useDispatch, useSelector } from "react-redux";
import {
	update,
	updateFiliaisList,
	updateFuncionarios,
} from "../../../redux/slicers/user";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ModalErrorPretty from "../../modal/ModalErrorPretty";

const nomeD = createRef(null);
const emailD = createRef(null);
const telefoneD = createRef(null);
const cpfD = createRef(null);
const cnhD = createRef(null);
const dataNascimentoD = createRef(null);
const dataValidadeCnh = createRef(null);
const userStatusD = createRef(null);
const senhaD = createRef(null);
const DescLocalSeparacaoD = createRef(null);
const pisD = createRef(null);

export default function UserCadastro() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const filiaisList = useSelector((state) => state.userSlice.filiaisList.data);

	const [user, setUser] = useState({
		name: "",
		email: "",
		telefone: "",
		cpf: "",
		cnh: "",
		tipo: "",
		id_filial: "",
		local_separacao: "",
		status: false,
		data_nascimento: "",
		password: "",
		typeImg: "CNH",
		fotoCnh: "",
		desc_setor_sep: "",
		error: {
			flag: false,
			msg: "",
		},
		pis: "",
	});

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({ show: false });
	const [selectedPropriedade, setSelectedPropriedade] = useState("");
	const [selectedTipo, setSelectedTipo] = useState("");
	const [selectedLocalSeparacao, setSelectedLocalSeparacao] = useState("");

	const onChangeInput = (e) => {
		e.preventDefault();
		setUser((last) => ({
			...last,
			name: nomeD.current.value.toUpperCase(),
			email: emailD.current.value.toUpperCase(),
			telefone: telefone_mask(telefoneD.current.value),
			cpf: cpf_mask(cpfD.current.value),
			pis: pis_mask(pisD.current.value),
			cnh: apenasNumeros(cnhD.current.value),
			tipo: selectedTipo,
			id_filial: selectedPropriedade,
			local_separacao: selectedLocalSeparacao,
			desc_setor_sep:
				selectedTipo === "Separador"
					? DescLocalSeparacaoD.current.value
					: "",
			password: senhaD.current.value,
			data_nascimento: dataNascimentoD.current.value,
			data_valid_cnh: dataValidadeCnh.current.value,
			error: { flag: false, msg: "" },
		}));
	};

	const onChangeInputFile = (e) => {
		e.preventDefault();

		setUser((last) => ({
			...last,
			fotoCnh: e.target.files[0],
		}));
	};

	const handlePropriedadeChange = (e) => {
		setSelectedPropriedade(e.target.value);
		setUser((last) => ({
			...last,
			id_filial: e.target.value,
		}));
	};

	const handleTipoChange = (e) => {
		const tipoValue = e.target.value;
		setSelectedTipo(tipoValue);
		setUser((last) => ({
			...last,
			tipo: tipoValue,
			local_separacao: tipoValue !== "Separador" ? "" : last.local_separacao,
			desc_setor_sep: tipoValue !== "Separador" ? "" : last.desc_setor_sep,
		}));
		
		if (tipoValue !== "Separador") {
			setSelectedLocalSeparacao("");
		}
	};

	const handleLocalSeparacaoChange = (e) => {
		setSelectedLocalSeparacao(e.target.value);
		setUser((last) => ({
			...last,
			local_separacao: e.target.value,
		}));
	};

	const updateFuncionariosList = () => {
		getFuncionarios().then((response) => {
			dispatch(updateFuncionarios(response));
			navigate("/user/cadastrados");
		});
	};

	const submitHandler = (e) => {
		e.preventDefault();
		if (!user.id_filial) return setError({ show: true, message: "Filial não selecionada" });
		if (!user.name || !user.name.trim().length) return setError({ show: true, message: "Nome não informado" });
		if (!user.email || !user.email.trim().length) return setError({ show: true, message: "Email não informado" });
		if (!user.cpf || !user.cpf.trim().length) return setError({ show: true, message: "CPF não informado" });
		if (!user.telefone || !user.telefone.trim().length) return setError({ show: true, message: "Telefone não informado" });
		if (!user.data_nascimento || !user.data_nascimento.trim().length) return setError({ show: true, message: "Data de nascimento não informada" });
		if (!user.pis || !user.pis.trim().length) return setError({ show: true, message: "PIS não informado" });
		if (!user.cnh || !user.cnh.trim().length) return setError({ show: true, message: "CNH não informada" });
		if (!user.tipo || !user.tipo.trim().length) return setError({ show: true, message: "Tipo não selecionado" });
		if (!user.password || !user.password.trim().length) return setError({ show: true, message: "Senha não informada" });
		if (user.tipo === "Separador" && (!user.local_separacao || !user.local_separacao.trim().length)) return setError({ show: true, message: "Setor da separação não informado" });
		if (user.tipo === "Separador" && (!user.desc_setor_sep || !user.desc_setor_sep.trim().length)) return setError({ show: true, message: "Descrição do setor de separação não informada" });

		setLoading(!loading);

		createFuncionario(user)
			.then((response) => {
				setLoading(false);
				updateFuncionariosList();
			})
			.catch((error) => {
				const message = error?.response?.data?.message || error?.message;
				setError({ show: true, message: message });
				setLoading(false);
			});
	};

	const onlyNumbersHandler = (e) => {
		// e.preventDefault()
		const buttonsAllowed = [
			"backspace",
			"alt",
			"arrowleft",
			"arrowright",
			"delete",
			"tab",
		].indexOf(e.key.toLowerCase());
		if (buttonsAllowed >= 0) {
		} else if (buttonsAllowed >= 0 || /[0-9]/g.test(e.key)) {
		} else {
			e.preventDefault();
			return false;
		}
	};

	return (
		<UserLayout>
			<Form onSubmit={submitHandler}>
				<h3 className="card-header">Dados Cadastrais</h3>
				<Row className="my-2">
					<Col md="4" className="mb-3">
						<Form.Label>Propriedade:</Form.Label>
						<SearchableSelect
							options={filiaisList.map((item) => ({
								value: item.idFilial,
								label: `${item.idFilial} - ${item.identificacaoInterna}`
							}))}
							value={selectedPropriedade}
							onChange={handlePropriedadeChange}
							placeholder="Selecione uma propriedade..."
							searchPlaceholder="Buscar propriedade..."
							name="propriedade"
						/>
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>Nome Completo:</Form.Label>
						<Form.Control
							type="text"
							placeholder="joao"
							
							ref={nomeD}
							value={user.name}
							onChange={onChangeInput}
						/>
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>Email:</Form.Label>
						<Form.Control
							type="email"
							placeholder="joao@gmail.com"
							
							ref={emailD}
							value={user.email}
							onChange={onChangeInput}
						/>
						{user?.error?.msg?.includes("email") ? (
							<Form.Text className="text-muted error-form">
								Email Já Cadastrado!
							</Form.Text>
						) : (
							""
						)}
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>CPF:</Form.Label>
						<Form.Control
							type="text"
							placeholder="Somente numeros"
							
							name="CPF"
							onKeyDown={onlyNumbersHandler}
							maxLength={14}
							ref={cpfD}
							onChange={onChangeInput}
							// pattern={/[0-9]/g}
							value={user.cpf}
						/>

						{user.error.msg.includes("cpf") ? (
							<Form.Text className="text-muted error-form">
								CPF Já Cadastrado!
							</Form.Text>
						) : (
							""
						)}
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>Telefone:</Form.Label>
						<Form.Control
							type="text"
							placeholder="00000000000"
							maxLength={15}
							
							ref={telefoneD}
							onKeyDown={onlyNumbersHandler}
							onChange={onChangeInput}
							value={user.telefone}
						/>
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>Data de Nascimento:</Form.Label>
						<Form.Control
							type="date"
							placeholder="xxxxxxx"
							ref={dataNascimentoD}
							onChange={onChangeInput}
						/>
					</Col>
				</Row>
				<h3 className="card-header mt-5">Informações do Documento</h3>
				<Row className="my-2">
					<Col md="4" className="mb-3">
						<Form.Label>PIS:</Form.Label>
						<Form.Control
							type="text"
							placeholder="00000000000"
							onKeyDown={onlyNumbersHandler}
							maxLength={14}
							ref={pisD}
							onChange={onChangeInput}
							
							value={user.pis}
						/>
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>CNH:</Form.Label>
						<Form.Control
							type="text"
							placeholder="00000000000"
							onKeyDown={onlyNumbersHandler}
							maxLength={11}
							ref={cnhD}
							onChange={onChangeInput}
							
							value={user.cnh}
						/>
						{user.error.msg.includes("cnh") ? (
							<Form.Text className="text-muted error-form">
								CNH Já Cadastrado!
							</Form.Text>
						) : (
							""
						)}
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>FOTO DA CNH:</Form.Label>
						<Form.Control
							type="file"
							name={user.name}
							onChange={onChangeInputFile}
						/>
						{user.error.msg.includes("imagem") ? (
							<Form.Text className="text-muted error-form">
								{user.error.msg}
							</Form.Text>
						) : (
							""
						)}
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>Validade da CNH :</Form.Label>
						<Form.Control
							type="date"
							placeholder="xxxxxxx"
							
							ref={dataValidadeCnh}
							onChange={onChangeInput}
						/>
					</Col>
				</Row>
				<h3 className="card-header mt-5">Informações do Usuário</h3>

				<Row className="my-2">
					<Col md="4" className="mb-3">
						<Form.Label>Tipo:</Form.Label>
						<SearchableSelect
							options={[
								{ value: "Caminhoneiro", label: "Motorista" },
								{ value: "Carregador", label: "Carregador" },
								{ value: "Gestor", label: "Gestor" },
								{ value: "Separador", label: "Separador" },
								{ value: "Financeiro", label: "Financeiro" }
							]}
							value={selectedTipo}
							onChange={handleTipoChange}
							placeholder="Selecione um tipo..."
							searchPlaceholder="Buscar tipo..."
							name="tipo"
						/>
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>Setor da Separação:</Form.Label>
						<SearchableSelect
							options={[
								{ value: "", label: "Selecione..." },
								{ value: "SETOR_1", label: "SETOR_1" },
								{ value: "SETOR_2", label: "SETOR_2" },
								{ value: "SETOR_3", label: "SETOR_3" },
								{ value: "SETOR_4", label: "SETOR_4" },
								{ value: "SETOR_5", label: "SETOR_5" },
								{ value: "SETOR_6", label: "SETOR_6" }
							]}
							value={selectedLocalSeparacao}
							onChange={handleLocalSeparacaoChange}
							placeholder="Selecione um setor..."
							searchPlaceholder="Buscar setor..."
							name="local_separacao"
							disabled={selectedTipo !== "Separador"}
						/>
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>Descricao do Setor de Separação:</Form.Label>
						<Form.Control
							ref={DescLocalSeparacaoD}
							onChange={onChangeInput}
							disabled={selectedTipo !== "Separador"}
							value={user.desc_setor_sep}
						/>
					</Col>
					<Col md="4" className="mb-3">
						<Form.Label>Senha:</Form.Label>
						<Form.Control
							type="text"
							placeholder="xxxxxxx"
							
							ref={senhaD}
							onChange={onChangeInput}
						/>
					</Col>
					<Col md="6" className="mb-3">
						<Form.Group>
							<Form.Label>Status:</Form.Label>
							<Form.Check
								type="switch"
								ref={userStatusD}
								onChange={() =>
									setUser((last) => ({ ...last, status: !user.status }))
								}
								label={user.status ? "Usuário Ativo" : "Usuário Inativo"}
							/>
						</Form.Group>
					</Col>
				</Row>
				<Row className="mx-auto justify-content-center my-5">
					<Col md="3" className="mb-3">
						<Button variant="primary" type="submit">
							{loading ? <Loading msg="Salvando" /> : "Salvar"}
						</Button>
					</Col>
					<Col md="3" className="mb-3">
						<Button variant="secondary" type="reset">
							Apagar
						</Button>
					</Col>
				</Row>
			</Form>
			{error.show ? <ModalErrorPretty setShow={setError} {...error} /> : ""}
		</UserLayout>
	);
}
